import { defineFetch } from 'resift';

export default defineFetch({
  displayName: 'Delete Entity Type',
  make: (entityTypeId: string) => ({
    request: () => ({ http }) =>
      http({
        method: 'DELETE',
        route: `/entity-types/${entityTypeId}`,
      }),
  }),
});
